import { lazy } from 'react';

import type { MachineTranslationEngine } from '@app/api/translation';
import { ReactWebComponent } from '@app/utils/web-components';

const AppProviders = lazy(() => import('@app/components/AppProviders'));
const EditorMachineTranslation = lazy(() => import('.'));

class EditorMachineTranslationComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['engines', 'translation-id', 'to-language-id', 'reference-lang-id'];
    }

    render() {
        const engines = this.jsonProp<readonly MachineTranslationEngine[]>('engines');
        const translationId = this.getAttribute('translation-id');
        const toLanguageId = this.getAttribute('to-language-id');
        const referenceLanguageId = this.getAttribute('reference-lang-id');

        if (!engines || !translationId || !toLanguageId || !referenceLanguageId) {
            return null;
        }

        return (
            <AppProviders>
                <EditorMachineTranslation
                    engines={engines}
                    translationId={translationId}
                    toLanguageId={toLanguageId}
                    referenceLanguageId={referenceLanguageId}
                />
            </AppProviders>
        );
    }
}

customElements.define('editor-machine-translation', EditorMachineTranslationComponent);
